<template>
  <div class="content">
    <el-row :gutter="12">
      <el-col :span="12" class="fix__top">
        <el-input
          class="style-fullWidth"
          v-model="filter.query"
          size="medium"
          placeholder="Tìm kiếm"
          prefix-icon="el-icon-search"
          @keydown.enter.exact.native="searchTree"
        ></el-input>
      </el-col>
    </el-row>

    <hashtag-common
      :selectedToUserDeptRoleIds="selectedToUserDeptRoleIds"
      @selectTags="selectTags"
      @unSelectTags="unSelectHashTag"
      :groupTypeId="GROUPS.GROUP_TYPE_ID.CA_NHAN"
    />

    <VuePerfectScrollbar
      class="scroll-scope listCompanies"
      :settings="settings"
    >
      <el-tree
        :data="roots"
        :filter-node-method="filterNode"
        ref="departmentTree"
        class="filter-tree"
        node-key="id"
        :default-expanded-keys="defaultExpandedKeys"
        show-checkbox
      >
        <div
          class="custom-tree-node flex-row flex__between width__100"
          slot-scope="{ node, data }"
        >
          <div class="field-1" @click.native.stop="() => false">
            <span>
<!--              <el-checkbox-->
<!--                v-model="data.checked"-->
<!--                @change="checkedChange(data)"-->
<!--              ></el-checkbox>-->
              <span
                v-if="
                  data.nodeType === DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                "
              >
                &nbsp;
                <span class="font-weight__bold">
                  {{ data.userDeptRole.fullName }}
                </span>
                <span class="font-size__small font-italic">
                  ({{ data.userDeptRole.positionName }})
                </span>
                <span style="position: relative">
                           <el-tooltip
                             v-if="data.userDeptRole.absentCount!=0"
                             :content="tooltipContent(data.userDeptRole)"
                             placement="right"
                             effect="dark">
                           <absent-notify></absent-notify>
                         </el-tooltip>
                </span>
              </span>
              <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
            </span>
          </div>
        </div>
      </el-tree>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import constants from "../../../constants";
import utils from "../../../services/utils";
import h from "../../../services/h";
import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import HashtagCommon from "../../doc-in/components/chuyenXuLy-hashtag";
import AbsentNotify from "../../common/absents/absent-notify";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  name: "banhanh-cc-tree",
  mixins: [handlersTreeMixin],
  components: {
    AbsentNotify,
    HashtagCommon,
    VuePerfectScrollbar
  },
  props: ["selectedToUserDeptRoleIds"],
  data() {
    return {
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      DEPARTMENT: constants.DEPARTMENT,
      GROUPS: constants.GROUPS,
      search: null,
      settings: {maxScrollbarLength: 750},
      isLoadingRoots: true,
      defaultExpandedKeys: [],
      filter: {
        query: null,
        showChecked: false
      }
    };
  },


  computed: {
    roleCode() {
      return this.$store.getters.userDeptRole.roleCode;
    },
    tenantCode() {
      return this.$store.getters.userDeptRole.tenantCode;
    },
  },

  methods: {
    tooltipContent(item){
      return `Vắng mặt từ ` + dateFormatter(item.absentStartTime) + ` đến ` + dateFormatter(item.absentDeadlineTime);
    },

    async setUserDeptRoleHandlers(userDeptRoleHandlers) {
      this.userDeptRoleHandlers = userDeptRoleHandlers;
      await this.buildNodes().then(() => {
        if(this.roots[0]) {
          this.defaultExpandedKeys = [this.roots[0].id]
        }

      })
      this.setExpandedNodeWhenHavingSelectedUsers()
    },

    // collapseAllNode(data) {
    //   h.each(data.children, child =>
    //     this.collapseAllNode(child)
    //   )
    //   const node = this.$refs.departmentTree2.getNode(data.id);
    //   if (node) node.expanded = false;
    //
    //   // expanded default
    //   const rootNode = this.$refs.departmentTree2.getNode(this.roots2[0].id);
    //   rootNode.expanded = true
    //   const btgdNode = this.$refs.departmentTree2.getNode(constants.DEPARTMENT_TREE.NODE_TYPE.BTGD);
    //   btgdNode.expanded = true
    // },

    setExpandedNodeWhenHavingSelectedUsers() {
      // if (this.selectedToUserDeptRoleIds.length > 0) {
      //   for (const userDeptRoleId of this.selectedToUserDeptRoleIds) {
      //     this.$refs.departmentTree.setChecked(userDeptRoleId, true);
      //     const node = this.$refs.departmentTree.getNode(userDeptRoleId);
      //     if (node && 'parent' in node) {
      //       node.parent.expanded = true
      //     }
      //   }
      // }

      const checkedNodes = h.collect(this.selectedToUserDeptRoleIds, item => {
        return this.$refs.departmentTree.getNode(item);
      });
      for (const node of checkedNodes) {
        this.$refs.departmentTree.setChecked(node.data.id, true);
        // if (node && 'parent' in node) {
        //   node.parent.expanded = true
        // }
      }
      this.refreshNodeExpand()
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.filter.query);
    },

    checkedAllChildren(data, checked) {
      h.each(data.children, child => {
        let checkedState = child.checked || false;
        if (checkedState !== checked) {
          this.$set(child, "checked", checked);
          if (
            data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
          )
            this.checkedAllChildren(child, checked);
        }
      });
    },

    // expand parent of checked node
    expandParent() {
      this.defaultExpandedKeys.splice(0);
      this.defaultExpandedKeys.push(this.roots[0].id); // Expand root node
      const checkNodes = this.$refs.departmentTree.getCheckedNodes();
      for (const checkNode of checkNodes) {
        if (checkNode.parent) {
          this.defaultExpandedKeys.push(checkNode.parent.id);
        }
      }
    },

    selectTags(event) {
      for (const item of event) {
        let node;
        if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD || item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV) {
          node = this.$refs.departmentTree.getNode(item.nodeType);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          node = this.$refs.departmentTree.getNode(item.handler.id);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          node = this.$refs.departmentTree.getNode(item.handler.id);
        }

        if (node) {
          this.$refs.departmentTree.setChecked(node.data, true);
          this.checkChange(node.data, true)
          this.expandParent();
        }
      }
    },

    unSelectHashTag(event) {
      for (const item of event) {
        let node;
        if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD || item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV) {
          node = this.$refs.departmentTree.getNode(item.nodeType);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          node = this.$refs.departmentTree.getNode(item.department.id);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          node = this.$refs.departmentTree.getNode(item.handler.id);
        }

        if (node) {
          this.$refs.departmentTree.setChecked(node.data, false);
        }
      }
    },

    markChecked_(data, isShouldCheckFn) {
      if (!data.checked) {
        let shouldCheck = isShouldCheckFn(data);
        if (shouldCheck) {
          this.$set(data, "checked", true);
          if (
            data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
          )
            this.checkedAllChildren(data, data.checked);
        } else {
          h.each(data.children, child =>
            this.markChecked_(child, isShouldCheckFn)
          );
          if (
            data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
          ) {
            if (!h.exists(data.children, child => !child.checked))
              this.$set(data, "checked", true);
          }
        }
      }
    },

    markCheckedForSelectedToUsers(selectedToUserIds) {
      if (selectedToUserIds && selectedToUserIds.length) {
        h.each(this.roots, root =>
          this.markChecked_(
            root,
            data =>
              data.nodeType ===
              constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
              selectedToUserIds.indexOf(data.userDeptRole.id) !== -1
          )
        );
      }
    },
    filterNode(value, data) {
      if (!value) {
        this.refreshNodeExpand();
        return true;
      }
      switch (data.nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          return utils.like(data.department.deptName, value);
        case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
          return utils.filterUserDeptRoleView(value, data.userDeptRole);
        default:
          return false;
      }
    },

    checkChange(data, isChecked) {
      const node = this.$refs.departmentTree.getNode(data);

      if (this.isBTGDAndHDTV(data)) {
        this.setCheckedForChildren(data, isChecked); // set checked cho children
        if (isChecked) {
          node.expanded = isChecked;
        }
      }
      this.$set(data, 'checked', isChecked);

      if (!this.isBTGDAndHDTV(data)) {
        if(data.parent){
          this.setCheckedForParent(data)
        }
        switch (data.nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            this.setCheckedForChildren(data, isChecked); // set checked cho children
            if (isChecked) {
              node.expanded = isChecked;
            }
            break;
          default:
            break;
        }
      }

      // Nếu không check tất cả các children của Ban Tổng giám đốc, Hội đồng thành viên thì sẽ k check node của Ban Tổng giám đốc, Hội đồng thành viên
      // const parentNode = node.parent;
      // if (parentNode && this.isBTGDAndHDTV(parentNode.data) && !isChecked) {
      //   parentNode.checked = false
      // }

      if (this.filter.showChecked && !isChecked) {
        this.$refs.departmentTree.filter(this.filter);
      }
    },

    isBTGDAndHDTV(data) {
      return data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD
        || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV
        || (data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT && data.department.deptCode === constants.HDTV_DEPT_CODE)
    },

    // Set checked cho children
    setCheckedForChildren(data, isChecked) {
      if (isChecked) {
        for (const children of data.children) {
          this.$refs.departmentTree.setChecked(children, isChecked);
          this.checkChange(children, isChecked)
        }
      } else {
        let isCheckedAllChildren = true;
        for (const children of data.children) {
          if (children.checked === false) {
            isCheckedAllChildren = false;
            break;
          }
        }
        if (isCheckedAllChildren) {
          for (const children of data.children) {
            this.$refs.departmentTree.setChecked(children, isChecked);
            // this.checkChange(children, isChecked)
          }
        }
      }
    },

    setCheckedForParent(data) {
      const parentNode = this.$refs.departmentTree.getNode(data.parent.id);
      if (parentNode && this.isBTGDAndHDTV(parentNode.data)) {
        const uncheckedSiblingData = h.find(parentNode.childNodes, item => item.checked === false);
        if (!uncheckedSiblingData) {
          parentNode.checked = true
        } else {
          parentNode.checked = false
        }
      }
    },

    getNodeLabel(node) {
      let nodeType = node.nodeType;
      switch (nodeType) {
        case this.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          return node.department.deptName || "-";
        case this.DEPARTMENT_TREE.NODE_TYPE.BTGD:
          return "Ban Tổng giám đốc";
        case this.DEPARTMENT_TREE.NODE_TYPE.HDTV:
          return "Hội đồng thành viên";
        case this.DEPARTMENT_TREE.NODE_TYPE.DVTT:
          return "Đơn vị trực thuộc";
        case this.DEPARTMENT_TREE.NODE_TYPE.PBCN:
          return "Phòng ban chức năng";
        case this.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT:
          return "Phòng ban CN & Đơn vị TT";
        default:
          return "-";
      }
    },

    getToHandlers() {
      const checkedDatas = this.$refs.departmentTree.getCheckedNodes(true);
      const userDeptRoles = h.collect(checkedDatas, item => item.userDeptRole)
      return userDeptRoles;
    },

    findAllParentIdsOfNodeDatas(datas) {
      if (datas.length === 0) {
        return [];
      }
      let parentIds = [];
      const parentDatas = [];
      for (const data of datas) {
        if ('parent' in data && parentIds.indexOf(data.parent.id) !== 1) {
          parentDatas.push(data.parent)
          parentIds.push(data.parent.id)
        }
      }
      parentIds = parentIds.concat(this.findAllParentIdsOfNodeDatas(parentDatas))
      parentIds.filter((item,index)=>{
        return (parentIds.indexOf(item) == index)
      })
      return parentIds;
    },

    refreshNodeExpand() {
      const checkedDatas = this.$refs.departmentTree.getCheckedNodes();
      const parentIds = this.findAllParentIdsOfNodeDatas(checkedDatas);

      this.collapseAllNode(this.roots[0]);

      for (const parentId of parentIds) {
        const node = this.$refs.departmentTree.getNode(parentId);
        if (node) {
          node.expanded = true;
        }
      }
    },

    collapseAllNode(data) {
      h.each(data.children, child =>
        this.collapseAllNode(child)
      )
      const node = this.$refs.departmentTree.getNode(data.id);
      if (node) node.expanded = false;

      // expanded default
      const rootNode = this.$refs.departmentTree.getNode(this.roots[0].id);
      rootNode.expanded = true
      const btgdNode = this.$refs.departmentTree.getNode(constants.DEPARTMENT_TREE.NODE_TYPE.BTGD);
      if (btgdNode) {
        btgdNode.expanded = true
      }
    }
  }
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  padding-bottom: 0;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  max-height: calc(100vh - 250px);
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/banhanh-cc-tree.vue